<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :height="320"
            :search="search"
            :fixed-header="true"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Usuários</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.name"
                                                label="Nome Completo*"
                                                :error-messages="nameErrors"
                                                @input="$v.editedItem.name.$touch()"
                                                @blur="$v.editedItem.name.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.email"
                                                label="Email*"
                                                :error-messages="emailErrors"
                                                @input="$v.editedItem.email.$touch()"
                                                @blur="$v.editedItem.email.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.idperfil"
                                                :items="selects.perfil.items"
                                                chips
                                                label="Perfil do Sistema"
                                                height="10"
                                                outlined
                                                item-value="idperfil"
                                                item-text="descricao_perfil"
                                                style="margin-right: 5px"
                                                :error-messages="perfilErrors"
                                                @input="$v.editedItem.idperfil.$touch()"
                                                @blur="$v.editedItem.idperfil.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0" cols="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.setor"
                                                label="Setor*"
                                                item-text="descricao_perfil"
                                                style="margin-left: 5px"
                                                :error-messages="setorErrors"
                                                @input="$v.editedItem.setor.$touch()"
                                                @blur="$v.editedItem.setor.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="editedIndex === -1" class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.password"
                                                label="Nova Senha*"
                                                style="margin-right: 5px"
                                                :error-messages="passwordErrors"
                                                type="password"
                                                autocomplete="new-password"
                                                @input="$v.editedItem.password.$touch()"
                                                @blur="$v.editedItem.password.$touch()"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col v-if="editedIndex === -1" class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                style="margin-left: 5px"
                                                outlined
                                                v-model="editedItem.repeatPassword"
                                                label="Confirma Senha*"
                                                :error-messages="repeatPasswordErrors"
                                                type="password"
                                                @input="$v.editedItem.repeatPassword.$touch()"
                                                @blur="$v.editedItem.repeatPassword.$touch()"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Usuário"
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    title="Remover Usuário"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import {required, email, sameAs, minLength} from 'vuelidate/lib/validators'
    import UsuarioAPI from "./../../api/usuario";

    export default {
        props: ['atualizarUsu'],
        name: "Acl",
        data: () => ({
            dialog: false,
            search:'',
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                },
                {
                    text: 'Nome Completo',
                    align: 'left',
                    value: 'name',
                },
                {text: 'Email', value: 'email'},
                {text: 'Setor', value: 'setor'},
                {text: 'Perfil', value: 'descricao_perfil'},
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            selects: {
                perfil: {
                    items: [],
                },
            },
            editedItem: {
                id: '',
                name: '',
                email: '',
                setor: '',
                idperfil: '',
                password: '',
                repeatPassword: ''
            },
            defaultItem: {
                id: '',
                name: '',
                email: '',
                setor: '',
                idperfil: '',
                password: '',
                repeatPassword: ''
            },
        }),

        validations: {
            editedItem: {
                name: {
                    required,
                    minLength: minLength(6)
                },
                email: {
                    required,
                    email
                },
                setor: {
                    required
                },
                idperfil: {
                    required,
                },
                password: {
                    required,
                    minLength: minLength(6)
                },
                repeatPassword: {
                    sameAsPassword: sameAs('password')
                }
            }
        },

        computed: {
            nameErrors() {
                const errors = []
                if (!this.$v.editedItem.name.$dirty) return errors
                !this.$v.editedItem.name.required && errors.push('Campo Obrigatório.')
                return errors
            },
            emailErrors() {
                const errors = []
                if (!this.$v.editedItem.email.$dirty) return errors
                !this.$v.editedItem.email.email && errors.push('Email incorreto.')
                !this.$v.editedItem.email.required && errors.push('Campo Obrigatório.')
                return errors
            },
            setorErrors() {
                const errors = []
                if (!this.$v.editedItem.setor.$dirty) return errors
                !this.$v.editedItem.setor.required && errors.push('Campo Obrigatório.')
                return errors
            },
            perfilErrors() {
                const errors = []
                if (!this.$v.editedItem.idperfil.$dirty) return errors
                !this.$v.editedItem.idperfil.required && errors.push('Campo Obrigatório.')
                return errors
            },
            passwordErrors() {
                const errors = []
                if (!this.$v.editedItem.password.$dirty) return errors
                !this.$v.editedItem.password.minLength && errors.push('A senha dever ser maior que 6 caracteres')
                !this.$v.editedItem.password.required && errors.push('Campo Obrigatório.')
                return errors
            },
            repeatPasswordErrors() {
                const errors = []
                if (!this.$v.editedItem.repeatPassword.$dirty) return errors
                !this.$v.editedItem.repeatPassword.sameAsPassword && errors.push('As senhas devem ser iguais.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Usúario' : 'Editar Usuário'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },

            atualizarUsu(){
                this.initialize()
            }
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                UsuarioAPI.getPerfis(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.perfil.items = response.data.perfis;
                            
                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                UsuarioAPI.getUsuarios(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.usuarios;
                            
                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover usuário?')) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        UsuarioAPI.deletar(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.editedItem = {}
                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }else{
                    this.editedItem = {}
                }

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if(this.editedItem.id > 0){
                    this.editedItem.repeatPassword = this.editedItem.password
                }

                if (!this.$v.$invalid) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        UsuarioAPI.salvar(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                    
                }
            },
        },
    }
</script>
<style scoped>
</style>